import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumAutocompleteModule } from '@capturum/ui/autocomplete';
import { InputPrefixDirective } from '@core/directives/input-prefix.directive';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-auto-complete-type',
  imports: [CapturumAutocompleteModule, FormlyModule, FormsModule, ReactiveFormsModule, InputPrefixDirective],
  templateUrl: './formly-auto-complete-type.component.html',
  styleUrl: './formly-auto-complete-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyAutoCompleteTypeComponent extends FieldType {}
